import _ from 'lodash';
import { replaceHighlightTag } from '@patsnap-utils/highlight';
export const name = 'ANC_ADD.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    const { PN, PATENT_ID } = row || {};
    const cellValue = _.get(row, prop);
    const links = _.map(cellValue, ({ OFFICIAL, ORIGINAL, EN, DISTRICT }) => {
        const content = EN ? OFFICIAL : ORIGINAL;
        const innerHTML = _highlightMixin_hlText(content);
        const link = <span title={replaceHighlightTag(content)} 
        // @ts-ignore
        domProps={{ innerHTML }} target="_blank" data-link-type={prop} data-link-data={content} data-patent-id={PATENT_ID} data-patent-no={PN}/>;
        let more = null;
        if (EN) {
            // @ts-ignore
            more = <span domProps={{ innerHTML: _highlightMixin_hlText(`(${EN})`) }}/>;
        }
        else if (DISTRICT) {
            // @ts-ignore
            more = <span domProps={{ innerHTML: _highlightMixin_hlText(` ${DISTRICT}`) }}/>;
        }
        return [link, more];
    });
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {links}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const result = _.map(row[column.property] || [], ({ OFFICIAL, EN, ORIGINAL, DISTRICT }) => {
        const content = EN ? OFFICIAL : ORIGINAL;
        let more = null;
        if (EN) {
            more = EN;
        }
        else if (DISTRICT) {
            more = DISTRICT;
        }
        return `${content}${more}`;
    });
    return result.join(',');
}
export default {
    renderDefault,
    exportMethod,
};
